import { pushEcommerceEvent } from '@app/infrastructure/gtm/pushEcommerceEvent';
import { GtmEventName } from '@app/domain/model/gtm/GtmEventName';
import { AddToCartData } from '@app/domain/model/gtm/AddToCartData';
import { EcommerceItem } from '@app/domain/model/gtm/EcommerceItem';

export function trackAddToCart(items: AddToCartData[]): void {
    if (items.length === 0) {
        return;
    }

    const totalValue = items.reduce((sum, item) => sum + item.price, 0);

    const ecommerceItems: EcommerceItem[] = items.map(item => ({
        item_name: item.itemName,
        item_id: item.itemId,
        price: item.price,
        item_category: item.itemCategory,
        item_variant: item.itemVariant,
        quantity: 1,
    }));

    pushEcommerceEvent(GtmEventName.AddToCart, {
        currency: 'EUR',
        value: totalValue,
        items: ecommerceItems,
    });
}
